// Copyright 2016 Sorama B.V.

import { Disposable } from "aurelia-framework";

export abstract class IUserSettingsService {
    abstract bind(
        groupKey: string,
        propertyName: string,
        object: unknown,
        toStorage?: (property: unknown) => string,
        fromStorage?: (storedValue: string) => unknown
    ): Promise<Disposable>;

    abstract bindUserSettingsProperty(object: object): Promise<Disposable>;

    abstract set(groupKey: string, key: string, value: string): Promise<void>;

    abstract get(groupKey: string, key: string): Promise<string>;

    abstract delete(groupKey: string, key: string): Promise<void>;

    abstract hasKey(groupKey: string, key: string): Promise<boolean>;

    abstract getKeys(groupKey: string): Promise<string[]>;
}
